import { Raycaster, Vector2, Vector3 } from "three";

import { Context } from "../../../context";

import { CameraMode } from "../../controller";

import { ControllerStrategy } from "../strategy";

/**
 * Double click a on player to use their personal cam
 */
export class TeleportPersonalControllerStrategy extends ControllerStrategy {
  private raycaster: Raycaster = new Raycaster();
  private pointer: Vector2 = new Vector2();
  private p: Vector3 = new Vector3();
  private current?: number = undefined;

  private pointerCb = (event: MouseEvent) => {
    const controller = this.registered;
    if (!controller || !controller.contextRef.container) return;
    if (this.registered?.mode !== CameraMode.PAIR) this.current = undefined;

    this.pointer.x =
      (event.offsetX / controller.contextRef.container.clientWidth) * 2 - 1;
    this.pointer.y =
      -(event.offsetY / controller.contextRef.container.clientHeight) * 2 + 1;

    const camera = controller.camera;
    const actors = controller.contextRef.world?.actors.getActors();
    if (!actors) return;

    let closest = undefined;
    let d2 = Infinity;

    this.raycaster.setFromCamera(this.pointer, camera);

    for (let actor of actors) {
      if (actor.positionId == this.current) continue;
      const hit = this.raycaster.ray.intersectBox(actor.hitbox, this.p);
      if (hit && hit.distanceToSquared(camera.position) < d2) {
        closest = actor.positionId;
        d2 = hit.distanceToSquared(camera.position);
      }
    }

    if (closest) {
      this.current = closest;
      this.registered?.setMode(CameraMode.PERSONAL, {
        focusedID: closest,
      });
    }
  };

  init(context: Context): ControllerStrategy {
    super.init(context);

    this.registered?.domRef.addEventListener("dblclick", this.pointerCb);

    return this;
  }

  teardown() {
    this.registered?.domRef.removeEventListener("dblclick", this.pointerCb);
  }
}
